import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { CheckObject } from "../models/campo-aggiuntivo";
import { Azienda } from "src/app/Admin/models/Azienda";

@Component({
    selector: 'app-dynamic-tabs',
    templateUrl: './dynamic-tabs.component.html'
})
export class DynamicTabsComponent implements OnInit {
  @Input() TaskSettings: {
    persona?: number, 
    cliente?: number, 
    clienteObject?: Azienda,
    hideFiltriFe?: boolean,
  } = {
    persona: null, 
    cliente: null, 
    clienteObject: null,
    hideFiltriFe: null,
  }
  @Input() CrudSetting: any = {ConcatParams: {}, filtro: {}};
  @Input() activeId: string = 'info';
  @Input() Padre: any;
  @Output() PadreChange = new EventEmitter<any>()
  @Output() OnChange = new EventEmitter<any>()
  @Input() Tabs: {
      id: string,
      tipo: 'task' | 'crud' | 'campi' | 'sezioni' | 'template' | 'component',
      params?: any,
      titolo: string,
      component?: any,
      filtri?: any[],//campi 
      filtro?: {}
      hideif?: CheckObject;
      sezioni?: any[], 
      campi?: any[],
      crud?: string,
    }[]
  @Input() AvailableTemplates: {
      id: string,
      template: TemplateRef<any> | any
    }[]
  @ViewChild('nontrovato', { static: true }) NotFound!: TemplateRef<any>;

  constructor (
      
  ) {}
  GetFiltro(filter){
    return Object.assign(filter ?? {}, this.CrudSetting?.filtro ?? {});

  }
  GetTemplate(id: string){
      return this.AvailableTemplates?.find(x=>x.id == id)?.template ?? this.NotFound;
  }
  ngOnInit(): void {
      
  }
}